// extracted by mini-css-extract-plugin
export const container = "card-module--container--2nDXw";
export const card = "card-module--card--3RJ3f";
export const childrenContainer = "card-module--childrenContainer--3BHt7";